<template>
    <el-dialog :title="title" :visible="dialogFormVisible" :before-close="handleClose" :closeOnClickModal="false">
        <el-form :label-width="labelwidth" ref="model" :model="model" :rules="rules" :label-position="labelPosition">
            <el-form-item label="单位名称" prop="Name">
                <el-input size="small" v-model="model.Name" auto-complete="off" placeholder="请输入用户ID" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="单位编码" prop="Code">
                <el-input size="small" v-model="model.Code" auto-complete="off" placeholder="请输入姓名" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="服务器地址" prop="ServerIP">
                <el-input size="small" v-model="model.ServerIP" auto-complete="off" placeholder="请输入密码" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="数据库登录账户" prop="Account">
                <el-input size="small" v-model="model.Account" auto-complete="off" placeholder="请输入密码" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="数据库密码" prop="Pwd">
                <el-input size="small" v-model="model.Pwd" auto-complete="off" placeholder="请输入密码" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="设备密码" prop="DevicePwd">
                <el-input size="small"  v-model="model.DevicePwd" auto-complete="off" placeholder="请输入密码" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="单位类型" prop="Level" style="text-align: left">
                <el-radio-group v-model="model.Level">
                    <el-radio label="高中"></el-radio>
                    <el-radio label="初中"></el-radio>
                    <el-radio label="小学"></el-radio>
                    <el-radio label="幼儿园"></el-radio>
                    <el-radio label="其他"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="开通语言" prop="Language">
                <el-checkbox-group v-model="model.Language" style="text-align: left">
                    <el-checkbox label="cn" name="cn">中文</el-checkbox>
                    <el-checkbox label="en" name="en">英文</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="人数限制" prop="LimitNumber">
                <el-input size="small" v-model.number="model.LimitNumber" auto-complete="off" placeholder="请输入限制人数" maxlength="100" type="number"></el-input>
            </el-form-item>
            <el-form-item label="所属地区">
                <el-col :span="6">
                    <el-form-item prop="Province">
                        <el-select v-model="model.Province" placeholder="请选择所在省" @change="handleProvinceChange">
                            <el-option :label="item.Province" :value="item.Province" v-for="(item,index) in provinceList" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col class="line" :span="2">省</el-col>
                <el-col :span="6">
                    <el-form-item prop="City">
                        <el-select v-model="model.City" placeholder="请选择所在市" @change="handleCityChange">
                            <el-option :label="item.City" :value="item.City" v-for="(item,index) in cityList" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col class="line" :span="2">市</el-col>
                <el-col :span="6">
                    <el-form-item prop="Area">
                        <el-select v-model="model.Area" placeholder="请选择所在区">
                            <el-option :label="item.Area" :value="item.Area" v-for="(item,index) in areaList" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col class="line" :span="2">区</el-col>
            </el-form-item>
            <el-form-item label="单位logo" prop="Logo" style="text-align: left">
                <el-upload class="upload-demo" action="" :on-exceed="handleLogoOver" :before-upload="beforeAvatarLogo" :http-request="handleHttpRequestLogo" :file-list="fileLogoList" accept="image/*" list-type="picture" :limit="limitLogo" multiple>
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">图片长宽比例为 1:1，大小不超过 300k, 类型只能是PNG和JPG格式</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="宣传图片" prop="Images" style="text-align: left">
                <el-upload class="upload-demo" :file-list="fileBannerList" :on-exceed="handleBannerOver" :http-request="handleHttpRequestBanner" :limit="limitBanner" accept="image/*" :before-upload="beforeAvatarBanner" :before-remove="handleBannerRemove" list-type="picture" action="">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">图片长宽比例为 4:3，单张大小不超过 200k, 最多可上传 5 张</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="单位经度" prop="Longitude">
                <el-input size="small" v-model="model.Longitude" auto-complete="off" placeholder="请输入密码" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="单位纬度" prop="Latitude">
                <el-input size="small" v-model="model.Latitude" auto-complete="off" placeholder="请输入密码" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="是否开启积分挖掘" prop="IsOpenPoints">
                <el-switch v-model="model.IsOpenPoints"></el-switch>
            </el-form-item>
            <el-form-item label="是否开启人脸识别">
                <el-switch v-model="isShowFaceFirmID" @change="handleFaceChange"></el-switch>
            </el-form-item>
            <el-form-item label="人脸厂商" v-if="faceCompanyList && faceCompanyList.length>0">
                <el-radio-group v-model="model.FaceFirmID">
                    <el-radio :label="item.FaceFirmID" v-for="item in faceCompanyList" :key="item.FaceFirmID" >{{item.FaceFirmName}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="消息推送方式">
                <el-checkbox-group v-model="model.PushMode" style="text-align: left">
                    <el-checkbox label="wechat" key="wechat" value="wechat">微信</el-checkbox>
                    <el-checkbox label="sms" key="sms" value="sms">短信</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='handleClose'>取消</el-button>
            <el-button size="small" type="primary" class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {
        UpdateCompany,
        GetProvinceList,
        GetCityList,
        GetAreaList,
        GetFaceFirmList
    } from '../../api/company'
    import {
        Upload
    } from '../../api/common'
    export default {
        data() {
            return {
                title: '编辑单位',
                name: 'add',
                labelwidth: '150px',
                labelPosition: 'right',
                limitLogo: 1,
                limitBanner: 5,
                baseURL: window.Global.baseURL,
                provinceList: [],
                cityList: [],
                areaList: [],
                isShowFaceFirmID: false,
                faceCompanyList: [],
                model: {
                    Name: null,
                    Code: '',
                    ServerIP: '',
                    Account: '',
                    Pwd: '',
                    Level: '',
                    Language: [],
                    Province: '',
                    City: '',
                    Area: '',
                    Logo: '',
                    Images: [],
                    Latitude: 0, //纬度
                    Longitude: 0, //经度
                    IsOpenPoints: false,
                    FaceFirmID: 0,
                    FaceFirmName: '',
                    LimitNumber: null,
                    PushMode: [],
                    DevicePwd: ''
                },
                rules: {
                    Name: [{
                        required: true,
                        message: '请输入单位名称',
                        trigger: 'blur'
                    }],
                    Code: [{
                        required: true,
                        message: '请输入单位编码',
                        trigger: 'blur'
                    }],
                    ServerIP: [{
                        required: true,
                        message: '请输入服务器地址',
                        trigger: 'blur'
                    }],
                    Account: [{
                        required: true,
                        message: '请输入数据库登录账户',
                        trigger: 'blur'
                    }],
                    Pwd: [{
                        required: true,
                        message: '请输入数据库密码',
                        trigger: 'blur'
                    }],
                    Level: [{
                        required: true,
                        message: '请输入单位类型',
                        trigger: 'blur'
                    }],
                    Language: [{
                        required: true,
                        message: '请选择单位语言',
                        trigger: 'change'
                    }],
                    LimitNumber: [{
                        required: true,
                        message: '请输入正确的限制人数',
                        trigger: 'blur',
                        type: 'number'
                    }],
                },
                fileLogoList: [],
                fileBannerList: []
            }
        },
        props: {
            dialogFormVisible: {
                required: true,
                type: Boolean
            },
            data: {
                required: true,
            }
        },
        mounted() {
          
            this.init();
        },
        watch: {
                'model.FaceFirmID': {
                    handler: function(newVal,oldVal) {
                        if(newVal) {
                            this.isShowFaceFirmID = true;
                            this.GetFaceFirmList();
                        }else{
                            this.FaceFirmName = '';
                        }
                    }
                }
            },
        methods: {
            init() {
                if (this.data) {
                    console.log(this.data)
                    this.handleLanguageToArray();
                    this.handlePushModeToArray();
                    this.handleLogoToArray();
                    this.handleImagesToArray();
                    this.model = this.data;
                    if (!this.model.Images) {
                        this.model.Images = []
                    }
                    this.GetProvinceList()
                }
            },
            handleLanguageToArray() {
                console.log(99)
                let Language;
                if (this.data.Language) {
                    if (this.data.Language.indexOf('|') != -1) {
                        Language = this.data.Language.split('|')
                    } else {
                        Language = this.data.Language.split(' ')
                    }
                    this.data.Language = Language;
                }
                console.log(this.data.Language)
            },
            handlePushModeToArray() {
                let PushMode = [];
                 if(typeof this.data.PushMode == 'string') {
                    if (this.data.PushMode.indexOf('|') != -1) {
                        PushMode = this.data.PushMode.split('|');
                    } else {
                        PushMode = this.data.PushMode.split(' ');
                    }
                    this.data.PushMode = PushMode;
                    console.log(this.data.PushMode)
                 }
            },
            handleLogoToArray() {
                let Logo;
                if (this.data.Logo) {
                    this.fileLogoList.push({
                        url: this.data.Logo,
                        name: ''
                    });
                }
            },
            handleImagesToArray() {
                if (this.data.Images && this.data.Images.length > 0) {
                    this.data.Images.forEach(item => {
                        this.fileBannerList.push({
                            url: item,
                            name: ''
                        })
                    });
                }
            },
            handleBannerRemove(file, fileBannerList) {
                if (file && file.status === "success") {
                    return this.$confirm('确认要删除该图片吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'error'
                    }).then(() => {
                        this.model.Images.forEach((element, index) => {
                            if (element === file.url) {
                                this.model.Images.splice(index, 1);
                            }
                        });
                    })
                }
            },
            handleBannerOver() {
                this.$message({
                    message: '最多可上传5张图片',
                    type: 'error'
                });
            },
            beforeAvatarBanner(file) {
                let isLimit100 = file.size / 1024 < 1024;
                if (!isLimit100) {
                    this.$message({
                        message: '图片大小不能超过1M',
                        type: 'error'
                    });
                    return false;
                }
            },
            handleLogoRemove(file) {
                if (file && file.status === "success") {
                    return this.$confirm('确认要删除该logo吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'error'
                    }).then(() => {
                        this.model.Logo = '';
                    })
                }
            },
            handleLogoOver() {
                this.$message({
                    message: '只能上传一张logo',
                    type: 'error'
                });
            },
            beforeAvatarLogo(file) {
                let isLimit100 = file.size / 1024 < 300;
                if (!isLimit100) {
                    this.$message({
                        message: 'logo大小不能超过300k',
                        type: 'error'
                    });
                    return false;
                }
            },
            handleSave() {
                if (this.model.Language && this.model.Language.length > 0 && Array.isArray(this.model.Language)) {
                    this.model.Language = this.model.Language.join('|');
                }
                if (this.model.PushMode && this.model.PushMode.length > 0 && Array.isArray(this.model.PushMode)) {
                    let PushMode = [];
                    this.model.PushMode.forEach(item=>{
                        if(item) {
                            PushMode.push(item);
                        }
                    })
                    this.model.PushMode = PushMode.join('|');
                }
                this.model.Code = this.model.Code.toUpperCase();
                this.$refs.model.validate((valid) => {
                    if (valid) {
                        this.UpdateCompany()
                    } else {
                        this.$message({
                            message: '请填写完整信息',
                            type: 'error'
                        });
                    }
                });
            },
            handleClose() {
                this.$emit('closeEditDialog')
            },
            UpdateCompany() {
                let Images = '';
                if (this.model.Images && this.model.Images.length > 0 && Array.isArray(this.model.Images)) {
                    Images = this.model.Images.join(';');
                }
                if(this.isShowFaceFirmID && !this.model.FaceFirmID) {
                    this.$message({
                        message: '人脸厂商不能为空',
                        type: 'error'
                    });
                    return false;
                }
                delete this.model.FaceFirmName;
                UpdateCompany(Object.assign(this.model, { Images: Images })).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '编辑成功',
                            type: 'success'
                        });
                        this.handleClose();
                    }
                })
            },
            handleHttpRequestLogo(a) {
                var formdata = new FormData();
                formdata.append('file', a.file)
                Upload(formdata).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '文件上传成功',
                            type: 'success'
                        });
                        this.model.Logo = this.baseURL + data.data.filePath;
                    }
                })
            },
            handleHttpRequestBanner(a) {
                var formdata = new FormData();
                formdata.append('file', a.file)
                Upload(formdata).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '文件上传成功',
                            type: 'success'
                        });
                        this.model.Images.push(this.baseURL + data.data.filePath)
                    }
                })
            },
            GetProvinceList() {
                GetProvinceList().then(data => {
                    if (!data.iserror) {
                        this.provinceList = data.data.List;
                    }
                })
            },
            handleProvinceChange(value) {
                this.model.Province = value;
                this.model.City = '';
                this.model.Area = '';
                this.GetCityList();
            },
            GetCityList() {
                GetCityList({ Province: this.model.Province }).then(data => {
                    if (!data.iserror) {
                        this.cityList = data.data.List;
                    }
                })
            },
            handleCityChange(value) {
                this.model.City = value;
                this.model.Area = '';
                this.GetAreaList();
            },
            GetAreaList() {
                GetAreaList({
                    Province: this.model.Province,
                    City: this.model.City
                }).then(data => {
                    if (!data.iserror) {
                        this.areaList = data.data.List;
                    }
                })
            },
            handleFaceChange(val) {
                if (val) {
                    this.GetFaceFirmList();
                } else {
                    this.faceCompanyList = [];
                    this.model.FaceFirmID = 0;
                    if(this.model.FaceFirmName) {
                        this.model.FaceFirmName = '';
                    }
                }
            },
            GetFaceFirmList() {
                GetFaceFirmList().then(data => {
                    if (!data.iserror) {
                        console.log(data.data.List)
                        this.faceCompanyList = data.data.List;
                    }
                })
            },
        }
    }
</script>

<style>

</style>